import { CircularProgress } from "@mui/material";
import {
    ExpressCheckoutElement,
    PaymentRequestButtonElement,
    useElements,
    useStripe,
} from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useDispatch } from "react-redux";
import { setAlert, setUser } from "../../../redux/actions";

const Wallets = ({
    clientSecret,
    currency,
    amount,
    onSuccess,
    setShow,
    preparing,
    setPreparing,
    canPay,
    setCanPay,
}) => {
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();
    const [confirmingPayment, setConfirmingPayment] = useState(false);

    useEffect(() => {
        return () => {
            setPreparing(true);
        };
    }, []);

    if (!stripe) {
        return (
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                `}
            >
                <CircularProgress />
            </div>
        );
    }

    const paymentRequest = stripe.paymentRequest({
        country: currency === "usd" ? "US" : "AU",
        currency: currency,
        total: {
            label: "Total",
            amount: amount, // Amount in cents
        },
        requestPayerName: true,
        requestPayerEmail: true,
    });

    // Check if the payment request can be processed (e.g., Google Pay)
    paymentRequest.canMakePayment().then((result) => {
        if (result && result.googlePay) {
            console.log("Google Pay is available.");
            setCanPay(true);
            setPreparing(false);
        } else {
            console.log("Google Pay is not available.");
            setCanPay(false);
            setPreparing(false);
        }
    });

    const onConfirm = async () => {
        if (!stripe || !elements || !clientSecret) return;
        setConfirmingPayment(true);
        const { error, paymentIntent, paymentMethod } =
            await stripe.confirmPayment({
                // `Elements` instance that's used to create the Express Checkout Element.
                elements,
                // `clientSecret` from the created PaymentIntent
                clientSecret,
                // Uncomment below if you only want redirect for redirect-based payments.
                redirect: "if_required",
                return_url: "/",
            });

        if (error) {
            setConfirmingPayment(false);

            // This point is reached only if there's an immediate error when confirming the payment. Show the error to your customer (for example, payment details incomplete).
            dispatch(
                setAlert({
                    show: true,
                    type: "error",
                    body: error.message || "Unable to process payment",
                })
            );
        } else {
            onSuccess();
            setConfirmingPayment(false);
            // Your customer will be redirected to your `return_url`.
            // setTimeout(() => {
            //     onSuccess();
            //     setConfirmingPayment(false);
            //     setShow(false);
            // }, 4000);
            // window.location.reload();
        }
    };

    const options = {
        emailRequired: true,
        paymentMethods: {
            googlePay: "always",
        },
    };

    return (
        <div id="checkout-page">
            {preparing ? (
                <div
                    css={css`
                        display: flex;
                        justify-content: center;
                    `}
                >
                    <CircularProgress size={28} />
                </div>
            ) : null}
            {canPay ? (
                <>
                    {confirmingPayment ? (
                        <div
                            css={css`
                                display: flex;
                                justify-content: center;
                            `}
                        >
                            <CircularProgress size={28} />
                        </div>
                    ) : null}

                    <div
                        css={css`
                            display: ${confirmingPayment ? "none" : "block"};
                        `}
                    >
                        <ExpressCheckoutElement
                            options={options}
                            onConfirm={onConfirm}
                        />
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default Wallets;
